import React from "react";
import { Text } from "@shopify/polaris";
import _ from "lodash";
import constant from "lib/constant/constant";

const propertyLabels = {
  "service-id": constant.SERVICE_ID,
};

const LineItemProperties = (props) => {
  const { properties = [], variation, isServiceLineItem = false } = props;

  return (
    !!isServiceLineItem &&
    properties.map((property) => {
      const label = propertyLabels[property.name] ? propertyLabels[property.name] : property.name;
      return _.isString(property.name) && _.isString(property.value) ? (
        <Text as="span" variation={variation}>{`${label}: ${property.value}`}</Text>
      ) : null;
    })
  );
};

export default LineItemProperties;
